import React, { useEffect, useState } from "react";
import ic_time from "../../images/ic_time_invite.svg";
import ic_calendar from "../../images/ic_calendar_invite.svg";
import axios from "axios";
import { base_url } from "../../utils/AxiosConfig";
import {
  getReadableDateDDMMYYYY,
  getReadableDateYYYYMMDD,
  getReadableTime,
} from "../../utils/utils";
import dayjs from "dayjs";

const TodayEventsCard = ({ selectedDateToEventsFromParent }) => {
  const [todayEventsArray, setTodayEventsArray] = useState([]);

  useEffect(() => {
    const today = dayjs().format("YYYY-MM-DD");
    fetchTodayEvents(today);
  }, []);

  useEffect(() => {
    if (selectedDateToEventsFromParent) {
      fetchTodayEvents(selectedDateToEventsFromParent);
    }
  }, [selectedDateToEventsFromParent]);

  const fetchTodayEvents = async (eventDate) => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    try {
      const apiURL = `${base_url}/api/CRMEventFilter/${companyCode}/ALL/-/-/-/-/${eventDate}/${eventDate}/-/-`;
      const response = await axios.get(apiURL);
      const data = response.data;
      //   const data = '';
      console.log("Today's Events:", data);
      setTodayEventsArray(data);
    } catch (error) {
      console.error("Error while fetching todays event!", error);
    }
  };

  return (
    //   <div className="flex flex-wrap items-center justify-center gap-2 space-y-3  max-h-80 overflow-auto bg-transparent">
    <div className="grid grid-cols-4 gap-2 space-y-3 max-h-60 overflow-auto bg-transparent ">
      {!todayEventsArray || todayEventsArray.length === 0 ? (
        <div className="col-span-4 flex flex-col items-center justify-center py-4 px-3 bg-white rounded-2xl border border-gray-100">
          <div className="bg-gray-100 p-4 rounded-full mb-3">
            <img
              src={ic_calendar}
              className="w-8 h-8 object-contain opacity-40"
            />
          </div>
          <p className="text-sm font-medium text-gray-500">No events today</p>
          <p className="text-xs text-gray-400 mt-1">
            Your schedule is clear for today
          </p>
        </div>
      ) : (
        todayEventsArray.map((item, index) => (
          <div
            key={index}
            className=" bg-white rounded-2xl shadow-sm p-2 border border-gray-100  hover:border-gray-200 transition-all duration-200 group"
          >
            {/* Header */}
            <div className="flex items-start justify-between mb-4">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <span className="inline-block w-2 h-2 rounded-full bg-blue-500 flex-shrink-0" />
                  <h3 className="text-sm font-semibold text-gray-900 leading-tight">
                    {item.event_name}
                  </h3>
                </div>
                <div className="flex items-center gap-1.5 ml-3.5">
                  <div className="w-5 h-5 rounded-full bg-gradient-to-br from-indigo-400 to-purple-500 flex items-center justify-center flex-shrink-0">
                    <span className="text-white text-[9px] font-bold">
                      {item.event_creator_name?.charAt(0)?.toUpperCase()}
                    </span>
                  </div>
                  <p className="text-xs text-gray-500 truncate">
                    <span className="text-gray-400">by</span>{" "}
                    <span className="font-medium text-gray-600">
                      {item.event_creator_name}
                    </span>
                    <span className="text-gray-400 ml-1">
                      · {item.event_creator_id}
                    </span>
                  </p>
                </div>
              </div>
            </div>

            {/* Divider */}
            {/* <div className="border-t border-gray-100" /> */}

            {/* Time & Date Row */}
            <div className="grid grid-cols-2 gap-3">
              <div className="flex items-center gap-3 bg-blue-50 rounded-xl p-3 border border-blue-100/70">
                <div className="bg-blue-100 p-2 rounded-lg flex-shrink-0">
                  <img src={ic_time} className="w-4 h-4 object-contain" />
                </div>
                <div className="min-w-0">
                  <p className="text-[10px] font-medium text-blue-400 uppercase tracking-wide">
                    Time
                  </p>
                  <p className="text-xs font-semibold text-blue-800 mt-0.5 truncate">
                    {getReadableTime(item.event_scheduledon)}
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-3 bg-purple-50 rounded-xl p-3 border border-purple-100/70">
                <div className="bg-purple-100 p-2 rounded-lg flex-shrink-0">
                  <img src={ic_calendar} className="w-4 h-4 object-contain" />
                </div>
                <div className="min-w-0">
                  <p className="text-[10px] font-medium text-purple-400 uppercase tracking-wide">
                    Date
                  </p>
                  <p className="text-xs font-semibold text-purple-800 mt-0.5 truncate">
                    {getReadableDateDDMMYYYY(item.event_scheduledon)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default TodayEventsCard;
